import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RestService } from 'src/app/services/rest.service';
import { GlobalvarsService } from 'src/app/services/globalvars.service';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent implements OnInit {

  devices: any[] = [];

  public token: any;
  public listView: boolean = false

  constructor(
    private router: Router,
    private globalvar: GlobalvarsService,
    private rest: RestService
  ) { }

  ngOnInit(): void {
    // Make sure we are logged in with a valid user
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getDevices(tmpToken.accessToken)
      .then(value => {
        this.devices.push(value)
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })
  }

  edit(itemId: any) {
    this.router.navigateByUrl('/devices/' + itemId);
  }

  assign(itemId: any) {
    this.router.navigateByUrl('/devices/assign/' + itemId);
  }

  add() {
    this.router.navigateByUrl('/devices/add/');
  }

  changeToList(gridView: boolean) {
    this.listView = gridView
  }
}
